export default {
  app: {
    languagePopup: {
      title: 'Olet tällä hetkellä {logo}:n englanninkielisellä sivulla.',
      subtitle: 'Haluatko vaihtaa omaan kieleesi?',
      cta: 'Vaihda kieleen {lang}',
    },
  },
};
